import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaEnvelope, FaTwitter } from 'react-icons/fa';
import '../styles/Footer.css';

function Footer() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <footer className="footer">
      <div className="footer-grid-bg" />
      <div className="footer-content">
        <div className="footer-brand">
          <span className="footer-logo">{isHome ? '<AK/>' : '<Ashish-Kumar/>'}</span>
          <p className="footer-tagline">Crafting the future, one line at a time.</p>
        </div>
        <div className="footer-social">
          <a href="https://github.com/ashishkumar-ui" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="https://www.linkedin.com/in/ashishkumar-ui/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="https://x.com/WatchAshish" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <FaTwitter />
          </a>
          {/* <a href="mailto:ashish@example.com" aria-label="Email">
            <FaEnvelope />
          </a> */}
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Ashish Kumar. All rights reserved.</p>
          <p className="footer-built">Built with React &amp; passion.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
